module.exports = __webpack_public_path__ + "img/bg-01.b3b570e9.jpg";